import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 同步接口, 清理本地数据缓存
 * @returns Promise<boolean>
 */
export const clearStorageSync = () => {
  const result = core.call<'fabric_storage.clearStorageSync', null, boolean>(
    'fabric_storage.clearStorageSync',
    null
  );
  const fabricErrors = filterFabricErrors(
    result.code,
    result.message,
    result.data
  );
  if (fabricErrors) {
    throw fabricErrors;
  } else {
    return result.data;
  }
};
